import * as React from 'react'; // eslint-disable-line
import styled from 'styled-components';

import { BREAKPOINT } from '../../packages/constants';

export interface GridColProps {
    children: React.ReactNode;
    bgColor?: string;
    width?: string;
    dev?: boolean;
}

interface Widths {
    oneQuarter: string;
    oneThird: string;
    oneHalf: string;
    twoThirds: string;
    threeQuarters: string;
    full: string;
    [key: string]: string;
}

const widths: Widths = {
    oneQuarter: '25%',
    oneThird: '33.3333%',
    oneHalf: '50%',
    twoThirds: '66.6667%',
    threeQuarters: '75%',
    full: '100%',
};

const getWidth = (value: string) => widths[value];

// TODO: use configurable gutter
const GridCol = styled.div`
    border: ${(props: GridColProps): string => (props.dev ? '1px solid red' : 'none')};
    background-color: ${(props: GridColProps) => props.bgColor || 'transparent'};
    box-sizing: border-box;
    padding: ${(props: GridColProps): string => (props.dev ? '5px' : '0')};
    margin-bottom: ${(props: GridColProps): string => (props.dev ? '5px' : '0')};
    width: 100%;

    @media (min-width: ${BREAKPOINT.TABLET}) {
        width: ${(props: GridColProps) => (props.width ? getWidth(props.width) : widths.full)};
    }
`;

export default GridCol;
